/**
 * AudioRecordService
 */
import axios from 'axios';
import { createFFmpeg, fetchFile } from '@ffmpeg/ffmpeg';

/* Private vars */

let mediaRecorder = null;
let audioChunks = [];
let audioBlob = null;
let lastError = '';
let timerStartMilisec = 0;
let timerEndMilisec = 0;


/* Public methods */

/* Returns a promise that results to true on success */
const initRecorder = async () => {
  try {
    const stream = await navigator.mediaDevices.
      getUserMedia({ audio: true })
    mediaRecorder = new MediaRecorder(stream, { audioBitsPerSecond: 327680 });
    mediaRecorder.addEventListener('dataavailable',
      (event) => mediaReorderDataavailableHandler(event));
  } catch (e) {
    lastError = "Could not create media Recorder: " + e.message;
    return false
  }
  return true;
};

/* Destroy! */
const destroyRecorder = () => {
  mediaRecorder.removeEventListener('dataavailable',
    (event) => mediaReorderDataavailableHandler(event));
};

/* Returns true on success */
const startRecording = () => {
  audioChunks = [];
  timerStartMilisec = Date.now();
  try {
    mediaRecorder.start();
  } catch (e) {
    return false;
  }
  return true;
};

/* returns promise */
const stopRecording = () => {
  timerEndMilisec = Date.now();
  const stop$ = new Promise((resolve, reject) => {
    mediaRecorder.addEventListener('stop', () => {
      resolve();
    });
  });
  mediaRecorder.stop();
  return stop$;
};

const saveTempFile = () => {

}

const getTimerMilisec = () => {
  if (mediaRecorder !== null && mediaRecorder.state === 'recording') {
    return Date.now() - timerStartMilisec;
  } else {
    return Math.max(timerEndMilisec - timerStartMilisec, 0);
  }
};

/* Returns promise with a binary string */
const getEncodedAudioMp3Data = async () => {
  const ffmpeg = createFFmpeg({log: true});
  await ffmpeg.load();
  console.log(getAudioUrl());
  ffmpeg.FS('writeFile', 'input', await fetchFile(getAudioUrl()));
  await ffmpeg.run('-i', 'input', 'output.mp3');
  const mp3Data = ffmpeg.FS('readFile', 'output.mp3');
  const mp3Blob = new Blob([mp3Data.buffer], { type: 'audio/mp3' })
  return await getAudioBlobContent(mp3Blob);
}

/* Returns promise with a binary string */
const getEncodedAudioWavData = async () => {
  const ffmpeg = createFFmpeg({log: true});
  await ffmpeg.load();
  console.log(getAudioUrl());
  ffmpeg.FS('writeFile', 'input', await fetchFile(getAudioUrl()));
  await ffmpeg.run('-i', 'input', 'output.wav');
  const wavData = ffmpeg.FS('readFile', 'output.wav');
  const wavBlob = new Blob([wavData.buffer], { type: 'audio/wav' })
  return await getAudioBlobContent(wavBlob);
}

/* Returns promise with a array { contents: binary, mimetype: string } */
const getAudioDataAsRecorded = async () => {
  console.log(audioChunks[0]);
  const blob = getAudioBlob();
  let mimetype = audioChunks[0].type
  if (mimetype) {
    mimetype = mimetype.replace(/;.*$/, '');
  }
  return {
    contents: await getAudioBlobContent(getAudioBlob()),
    mimetype: mimetype,
  };
}

/* Returns promise that returns a binary string */
const getAudioBlobContent = (blob) => {
  const fileReader = new FileReader();
  const readerPromise = new Promise((resolve) => {
    fileReader.onload = function() {
      resolve(fileReader.result);
    }
  });
  fileReader.readAsBinaryString(blob);
  return readerPromise;
}

const getAudioBlob = () => {
  return new Blob(audioChunks, { type: audioChunks[0].type });
}

const getAudioUrl = () => {
  return window.URL.createObjectURL(getAudioBlob());
};

const getLastError = () => {
  return lastError;
};


/* Private methods */

const mediaReorderDataavailableHandler = (event) => {
  audioChunks.push(event.data);
};

/* returns promise */
const stopMediaRecorder = () => {
}

/* Object exported */

export default {
  initRecorder,
  destroyRecorder,
  startRecording,
  stopRecording,
  getTimerMilisec,
  getAudioUrl,
  getEncodedAudioMp3Data,
  getEncodedAudioWavData,
  getAudioDataAsRecorded,
  getLastError,
};
